import React from 'react';
import Image from 'next/image';

function ProjectCard({ project }) {
	return (
		<div
			className="flex flex-col max-w-sm px-3 py-2 mx-auto transition duration-300 ease-in-out bg-opacity-75 border rounded-lg border-fun-gray projects-center md:projects-start md:justify-center bg-gray-50 dark:bg-gray-900 dark:bg-opacity-75 backdrop-filter backdrop-blur-sm dark:text-white"
			key={project.id}>
			<a
				href={project.link || project.github}
				target="_blank"
				className={`w-full relative rounded-xl transition hover:-translate-y-2 hover:opacity-75 hover:border-fun-pink will-change-projectCard`}
				rel="noreferrer">
				<Image
					className="w-full rounded-md"
					alt=""
					objectFit="fill"
					src={project.img}
					layout="responsive"
					width={480}
					height={270}
				/>
			</a>
			<div className="w-full mt-5">
				<div className="flex justify-between projects-center">
					<a href={project.link || project.github} target="_blank" rel="noreferrer">
						<h3 className="text-lg font-bold">{project.title}</h3>
					</a>
					<div className="space-x-2">
						{project.link && (
							<a href={project.link} target="_blank" rel="noreferrer">
								<Image
									src="/static/icons/external-link.svg"
									width={16}
									height={16}
									alt="Link Icon"
								/>
							</a>
						)}
						{project.github && (
							<a href={project.github} target="_blank" rel="noreferrer">
								<Image
									src="/static/icons/github.svg"
									width={16}
									height={16}
									alt="Github Icon"
								/>
							</a>
						)}
					</div>
				</div>
				<p className="text-sm text-left text-fun-gray">{project.desc}</p>
				<ul className="flex flex-wrap items-center mt-2 -ml-2 list-none">
					{project.tags.map((tag, index) => {
						return (
							<li key={tag}>
								<div className="px-2 py-1 m-1 text-sm bg-blue-100 rounded-lg cursor-pointer dark:bg-gray-500 hover:opacity-75">
									{tag}
								</div>
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
}

export default ProjectCard;
